(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function initEditorial(root) {
    var article = root.querySelector('#pp-ed-article');
    var content = root.querySelector('[data-pp-ed-content]');
    var progress = root.querySelector('[data-pp-ed-progress]');
    var heroImage = root.querySelector('[data-pp-ed-hero-image]');

    initProgress(article, progress);
    initFade(root);
    initToc(root, content);
    initHeroParallax(heroImage);
    initMidArticleBuycard(root, content);
    initCart(root);
    initFaq(content);
    initFaqSchema(content);
  }

  function initProgress(article, progress) {
    if (!article || !progress) return;

    var update = function () {
      var rect = article.getBoundingClientRect();
      var articleTop = window.scrollY + rect.top;
      var articleHeight = article.offsetHeight || 1;
      var scrolled = window.scrollY - articleTop;
      var pct = Math.max(0, Math.min(100, (scrolled / articleHeight) * 100));
      progress.style.width = pct + '%';
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function initFade(root) {
    var content = root.querySelector('[data-pp-ed-content]');

    if (content) {
      content.classList.remove('pp-ed-fade-up');
      content.classList.add('is-visible');
    }

    var fadeEls = Array.prototype.slice.call(root.querySelectorAll('.pp-ed-fade-up'));

    if (content) {
      Array.prototype.forEach.call(content.children, function (child) {
        if (!child.classList.contains('pp-ed-fade-up')) {
          child.classList.add('pp-ed-fade-up');
        }
        fadeEls.push(child);
      });
    }

    if (!fadeEls.length) return;

    if (!('IntersectionObserver' in window)) {
      fadeEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 80px 0px' });

    fadeEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initToc(root, content) {
    var toc = root.querySelector('[data-pp-ed-toc]');
    var tocWidget = root.querySelector('[data-pp-ed-toc-widget]');
    if (!toc || !content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'))
      .filter(function (heading) {
        return heading.textContent.trim().length > 0;
      });

    if (!headings.length) {
      if (tocWidget) tocWidget.hidden = true;
      return;
    }

    var usedIds = {};
    headings.forEach(function (heading, index) {
      var base = heading.id || slugify(heading.textContent);
      var unique = base;
      var suffix = 2;

      while (usedIds[unique] || document.getElementById(unique)) {
        if (document.getElementById(unique) === heading) break;
        unique = base + '-' + suffix;
        suffix += 1;
      }

      usedIds[unique] = true;
      heading.id = unique;

      var item = document.createElement('li');
      var link = document.createElement('a');
      var num = document.createElement('span');
      var label = document.createElement('span');

      link.className = 'pp-ed-toc-link';
      link.href = '#' + unique;
      num.className = 'pp-ed-toc-num';
      num.textContent = String(index + 1).padStart(2, '0');
      label.textContent = heading.textContent.trim();

      link.appendChild(num);
      link.appendChild(label);
      item.appendChild(link);
      toc.appendChild(item);
    });

    if (!('IntersectionObserver' in window)) return;

    var links = Array.prototype.slice.call(toc.querySelectorAll('.pp-ed-toc-link'));
    var activeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

    headings.forEach(function (heading) {
      activeObserver.observe(heading);
    });
  }

  function initHeroParallax(heroImage) {
    if (!heroImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var update = function () {
      var y = window.scrollY;
      if (y < 650) {
        heroImage.style.transform = 'translateY(' + (y * 0.15) + 'px)';
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initMidArticleBuycard(root, content) {
    if (!root || !content) return;
    if (content.querySelector('[data-pp-ed-mid-buycard]')) return;
    var bottomCard = root.querySelector('[data-pp-ed-buycard]');
    if (!bottomCard) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var targetHeading = headings[Math.min(2, Math.floor(headings.length / 2))];
    if (!targetHeading || !targetHeading.parentNode) return;

    var midCard = bottomCard.cloneNode(true);
    midCard.setAttribute('data-pp-ed-mid-buycard', 'true');
    midCard.style.margin = '2.25rem 0';
    targetHeading.parentNode.insertBefore(midCard, targetHeading);
  }

  function initCart(root) {
    var forms = root.querySelectorAll('[data-pp-ed-cart-form]');
    if (!forms.length) return;

    Array.prototype.forEach.call(forms, function (form) {
      var select = form.querySelector('[data-pp-ed-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var card = form.closest('.pp-ed-product-body, [data-pp-ed-buycard]');
          if (!card || !opt) return;
          var priceEl = card.querySelector('[data-pp-ed-price]');
          var compareEl = card.querySelector('[data-pp-ed-compare]');
          if (priceEl && opt.getAttribute('data-price')) {
            priceEl.textContent = opt.getAttribute('data-price');
          }
          if (compareEl) {
            var cmp = opt.getAttribute('data-compare');
            compareEl.textContent = cmp || '';
            compareEl.style.display = cmp ? '' : 'none';
          }
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        var error = form.querySelector('[data-pp-ed-product-error]');
        var idInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('input[name="quantity"]');
        var variantId = idInput ? idInput.value : '';
        var quantity = quantityInput ? Number(quantityInput.value || 1) : 1;
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        var originalText = button ? button.textContent : '';

        if (!variantId) return;

        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
          button.textContent = 'Adding...';
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: quantity }]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (payload) {
                throw new Error(payload.description || payload.message || 'Unable to add this product.');
              });
            }
            return response.json();
          })
          .then(function (payload) {
            try {
              var addedItem = payload && payload.items && payload.items[0] ? payload.items[0] : payload;
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'add_to_cart', {
                  currency: 'USD',
                  value: addedItem && addedItem.price ? addedItem.price / 100 : undefined,
                  items: [{
                    item_id: String(variantId),
                    item_name: (addedItem && addedItem.product_title) || 'PathPal Golf Training Aid',
                    quantity: quantity
                  }],
                  transport_type: 'beacon'
                });
              }
            } catch (e) {}
            setTimeout(function () {
              window.location.href = cartUrl;
            }, 180);
          })
          .catch(function (err) {
            if (error) {
              error.textContent = err.message || 'Unable to add this product. Please try again.';
              error.hidden = false;
            }
            if (button) {
              button.disabled = false;
              button.classList.remove('is-loading');
              button.textContent = originalText || button.getAttribute('data-pp-ed-add-text') || 'Add to Cart';
            }
          });
      });
    });
  }

  function initFaq(content) {
    if (!content) return;

    var items = Array.prototype.slice.call(
      content.querySelectorAll('.pp-faq-item, [data-faq-item]')
    );
    if (!items.length) return;

    items.forEach(function (item) {
      var question = item.querySelector('.pp-faq-question, [data-faq-question]');
      var answer = item.querySelector('.pp-faq-answer, [data-faq-answer]');
      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) { other.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initFaqSchema(content) {
    if (!content) return;

    var faqItems = Array.prototype.slice.call(content.querySelectorAll('.faq-item, .pp-faq-item, [data-faq-item]'));
    if (!faqItems.length) return;

    var entities = faqItems.map(function (item) {
      var question = item.querySelector('.faq-question, .pp-faq-question, [data-faq-question]');
      var answer = item.querySelector('.faq-answer, .pp-faq-answer, [data-faq-answer]');

      if (!question || !answer) return null;

      var questionText = question.textContent.trim();
      var answerHtml = answer.innerHTML.trim();
      if (!questionText || !answerHtml) return null;

      return {
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerHtml
        }
      };
    }).filter(Boolean);

    if (!entities.length) return;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });

    document.head.appendChild(script);
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pp-editorial]'), initEditorial);
  });
})();
